"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sectionsTags = _interopRequireDefault(require("./sections-tags"));
var _screenList = _interopRequireDefault(require("./screen-list"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var OPPORTUNITY = '/opportunity/';
var EDIT_OPPORTUNITY = "".concat(OPPORTUNITY, ":opportunityId");
var LEVEL = '/level/';
var origins = {
  PROFILE: 'profile',
  LEVELS: 'levels',
  HOME: 'home',
  OPPORTUNITY: 'opportunity',
  DASHBOARD: 'dashboard'
};
var routes = {
  // Commons Routes
  ROOT: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  // Employer Routes
  EDIT_OPPORTUNITY: EDIT_OPPORTUNITY,
  NEW_OPPORTUNITY: "".concat(OPPORTUNITY, "new"),
  REVIEW_OPPORTUNITY_TAB: "".concat(EDIT_OPPORTUNITY, "?tab=Review"),
  EDIT_OPPORTUNITY_TAB: "".concat(EDIT_OPPORTUNITY, "?tab=Edit"),
  INTERNSHIPS: '/internships',
  COMPANY: '/company',
  NEW_COMPANY: '/company/new',
  SUPPORT: '/support',
  CHANGE_PASSWORD: '/change-password',
  RECOVERY_PASSWORD: '/recovery',
  // Student Routes
  LEVELS: '/levels',
  PROFILE: '/profile',
  RESUME: '/my-resume',
  ACCOUNT: '/my-account',
  HOME: '/home',
  OPPORTUNITIES: '/opportunities',
  COMPANIES: '/companies',
  REGISTER: '/register',
  RECOVERY: '/recovery',
  UPLOAD_PHOTO: '/uploadPhoto',
  ON_BOARDING: '/on-boarding',
  DIVERSITY_TO_HOME: "/diversity?redirect=".concat(origins.HOME),
  RESUME_WITH_REDIRECT_TO_LEVELS: "/my-resume?redirect=".concat(origins.LEVELS),
  DIVERSITY_TO_PROFILE: "/diversity?redirect=".concat(origins.PROFILE),
  DIVERSITY_TO_PROFILE_ADDITIONAL_INFORMATION: "/diversity?redirect=".concat(origins.PROFILE, "&screen=").concat(_screenList.default.additionalInformation),
  DIVERSITY_TO_PROFILE_WORK_ELIGIBILITY: "/diversity?redirect=".concat(origins.PROFILE, "&screen=").concat(_screenList.default.workEligibility),
  LEVEL_BULLETS_BUZZ_WITHOUT_ORIGIN: "".concat(LEVEL, "1C?screen=bullets_buzz"),
  LEVEL_NAME: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.NAME, "&origin=").concat(origins.PROFILE),
  LEVEL_ADDRESS: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.ADDRESS, "&origin=").concat(origins.PROFILE),
  LEVEL_LINKEDIN: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.LINKED_IN, "&origin=").concat(origins.PROFILE),
  LEVEL_INDUSTRIES: "".concat(LEVEL, "PC?screen=").concat(_sectionsTags.default.INDUSTRIES, "&origin=").concat(origins.PROFILE),
  LEVEL_FUNCTIONS: "".concat(LEVEL, "PC?screen=").concat(_sectionsTags.default.JOB_FUNCTIONS, "&origin=").concat(origins.PROFILE),
  LEVEL_CAREERS: "".concat(LEVEL, "PC?screen=").concat(_sectionsTags.default.CAREER_KEYWORDS, "&origin=").concat(origins.PROFILE),
  LEVEL_SEARCH: "".concat(LEVEL, "PC?screen=").concat(_sectionsTags.default.SEARCH_STATUS, "&origin=").concat(origins.PROFILE),
  LEVEL_COURSEWORK: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.COURSEWORK, "&origin=").concat(origins.PROFILE),
  LEVEL_BULLETS_BUZZ: "".concat(LEVEL, "1C?screen=").concat(_sectionsTags.default.BULLETS_BUZZ, "&origin=").concat(origins.PROFILE),
  LEVEL_MAJOR_AND_DEGREE: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.DEGREE_MAJOR, "&origin=").concat(origins.PROFILE),
  LEVEL_MINORS: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.MINOR, "&origin=").concat(origins.PROFILE),
  LEVEL_CONCENTRATIONS: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.CONCENTRATION, "&origin=").concat(origins.PROFILE),
  LEVEL_COLLEGIATE: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.COLLEGIATE_ATHLETICS, "&origin=").concat(origins.PROFILE),
  LEVEL_GPA: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.GPA, "&origin=").concat(origins.PROFILE),
  LEVEL_HONORS: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.HONORS, "&origin=").concat(origins.PROFILE),
  LEVEL_SCHOLARSHIP: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.SCHOLARSHIP, "&origin=").concat(origins.PROFILE),
  LEVEL_ENHANCED: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.ENHANCED_EXP, "&origin=").concat(origins.PROFILE),
  LEVEL_STUDY_ABROAD: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.STUDY_ABROAD, "&origin=").concat(origins.PROFILE),
  LEVEL_HIGH_SCHOOL: "".concat(LEVEL, "1A?screen=").concat(_sectionsTags.default.HIGH_SCHOOL_INFO, "&origin=").concat(origins.PROFILE),
  LEVEL_TECHNICAL_SKILLS: "".concat(LEVEL, "1B?screen=").concat(_sectionsTags.default.TECHNICAL_SKILLS, "&origin=").concat(origins.PROFILE),
  LEVEL_FOREIGN_LANGUAGE: "".concat(LEVEL, "1B?screen=").concat(_sectionsTags.default.LANGUAGE_SKILLS, "&origin=").concat(origins.PROFILE),
  LEVEL_PERSONAL_INTEREST: "".concat(LEVEL, "1B?screen=").concat(_sectionsTags.default.PERSONAL_INTERESTS, "&origin=").concat(origins.PROFILE),
  LEVEL_CERTIFICATIONS: "".concat(LEVEL, "1B?screen=").concat(_sectionsTags.default.CERTIFICATIONS_LICENCES, "&origin=").concat(origins.PROFILE),
  LEVEL_WRITING: "".concat(LEVEL, "PC?screen=").concat(_sectionsTags.default.WRITING_SAMPLES, "&origin=").concat(origins.PROFILE)
};
var _default = routes;
exports.default = _default;